export default __webpack_public_path__ + "static/palette-neutral-mapping-abb9738b55439e100692d9efe2f5ffb3b68576abf042f89ab3af29874eb4a7c7.png";